import {
  ADD_FOLLOWUP,
  FOLLOWUP_ERROR,
  FOLLOWUP_LIST,
  GETFOLLOWUP_DETAIL,
  GET_BOOKING_TYPE,
  GET_FOLLOWUP,
  GET_LEAD_TYPE,
  GET_REGISTRAION_TYPE,
  GET_SITEVISIT_TYPE,
  UPDATEFOLLOWUP,
  UPDATE_STATUS,
  SCHEDULED_FOLLOWUP_ACTIVITY,
  MARK_SCHEDULED_FOLLOWUP
} from "../types";

const initialState = {
  response: {},
  loading: true,
  create: false,
  detail: false,
};
const initialStateLeadType = {
  response: null,
  loading: true,
};
const initialStateSiteVisitType = {
  response: null,
  loading: true,
};
const initialStateBookingType = {
  response: null,
  loading: true,
};
const initialStateRegistrationType = {
  response: null,
  loading: true,
};

export default function followUpStore(state = initialState, action) {
  switch (action.type) {
    case GET_FOLLOWUP:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    case FOLLOWUP_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
        addFollowupresponse: null,
      };
    case GETFOLLOWUP_DETAIL:
      return {
        ...state,
        loading: false,
        create: true,
        detail: true,
        response: action.payload,
      };
    case UPDATEFOLLOWUP:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        response: action.payload,
      };
    case UPDATE_STATUS:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        response: action.payload,
      };
    case FOLLOWUP_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    case ADD_FOLLOWUP:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        addFollowupresponse: action.payload,
      };
    case SCHEDULED_FOLLOWUP_ACTIVITY:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        response: action.payload,
      };
      case MARK_SCHEDULED_FOLLOWUP:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function leadTypeReducer(state = initialStateLeadType, action) {
  switch (action.type) {
    case GET_LEAD_TYPE:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function siteVisitTypeReducer(
  state = initialStateSiteVisitType,
  action
) {
  switch (action.type) {
    case GET_SITEVISIT_TYPE:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function bookingTypeReducer(state = initialStateBookingType, action) {
  switch (action.type) {
    case GET_BOOKING_TYPE:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function registrationTypeReducer(
  state = initialStateRegistrationType,
  action
) {
  switch (action.type) {
    case GET_REGISTRAION_TYPE:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
